module.exports = "/_next/static/images/a2d56286167dd1f47e6a0e832e076ba5-challenge-the-system-xs@1x.jpg.webp";